// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2tzfR","selected":"Chip_selected__3Lv3U"};